<template>
  <div class="wapper"
       v-if="isLogin && isPower">
    <div class="menu-wapper">
      <div class="logo">
        <img :src="require(`@/assets/${$platform}_logo.png`)" v-if="!channelInfo.logoUrl">
				<img class="logo"
					:src="channelInfo.logoUrl"
					alt="logo" v-if="channelInfo.logoUrl">
      </div>
      <ul class="menu-list"
          v-if="null != menuList">
        <li v-for="(menu, index) in menuList"
            :key="index">
          <a :class="menu.show != true ? 'menu-title' : 'menu-title close'"
             href="javascript:void(0);"
             @click="cutMenu(index, menu.show)">{{menu.name}}</a>
          <ul class="menu-children"
              v-if="menu.show != true">
            <li class="menu-children-item"
                v-for="(item, index) in menu.children"
                :key="index">
              <router-link :to="item.url + '?power=' + item.id"
                           exact>
                {{item.name}}
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="content-wapper">
      <!-- 菜单 -->
      <div class="nav-wapper"
           v-if="isLogin">
        <!-- 切换系统 -->
        <div class="nav-system"
             @click="cutSystem">切换系统</div>
        <!-- 使用说明 -->
        <a href="javascript:void(0);"
           class="instructions-btn"
           @click="goUpdateLogs">更新日志</a>
        <div v-if="null != loginUser">
          <img :src="loginUser.avatar  || 'https://rs.juyoufuli.com/assets/staffs/timg.jpg'"
               @mouseover="isMenu = true">
          <div class="nav-menu"
               v-show="isMenu"
               @mouseleave="isMenu = false">
            <ul>
              <li @click="getDetail">个人信息</li>
              <li @click="loginOut">账号登出</li>
              <li @click="getDetail">切换部门</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="main-wapper">
        <div>
          <StepPage v-if="$route.meta.isStep"></StepPage>
          <router-view v-else />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import _menu from '@/service/menu-service'
import _userinfo from '@/service/userinfo-service'
import _constant from '@/utils/constant'
import _cookies from 'js-cookie'
import _request from '@/utils/request.js'
import config from '@/config/config.js'
import _channel from '@/service/channel-service';
import StepPage from './common/StepPage.vue'
var NODE_ENV = process.env.NODE_ENV;
Vue.prototype.$platform = config.platform
export default {
  components:{
    StepPage
  },
  data () {
    return {
			channelInfo:{
				channelName:null,
				logoUrl: null
			},
      currentSystem: {
        id:(NODE_ENV == "production" || NODE_ENV == "test") && this.$platform=='juyoufuli'  ? 329 :(NODE_ENV == "test" || NODE_ENV == "dev")&&329,
        name: 'CRM管理平台'
      },
      isLogin: false,
      isPower: false,
      isMenu: false,
      isSystemMenu: false,
      systemMenus: null,
      menuList: null,
      loginUser: null,
      childMenus: null
    }
  },
    computed: {
        currentSystemId() {

            if (config.platform == 'juyoufuli'&&NODE_ENV!='production') {
                return this.currentSystem.id=329
            }



        }
    },
  created () {
    console.log(NODE_ENV)
    // 查询登录用户
    _userinfo.getLoginUser(response => {
      this.isLogin = true
      this.loginUser = response
      _menu.getOperationsByPowerId(power => {
        this.$setPower(power)
        this.isPower = true
      })
			this.getChannel(response)
    })
    // 查询用户系统级别菜单
    var isSystem = 1;
    _menu.getMenuTreeList(isSystem, null, response => {
      this.systemMenus = response
      if (this.systemMenus == null || this.systemMenus.length < 1) {
        return
      }
      // 获取系统下菜单
      _menu.getMenuTreeList(null, this.currentSystem.id, response => {
        this.menuList = response
        if (this.menuList == null || this.menuList.length < 1) {
          // 无权限
          this.$router.push({
            path: '/notPower'
          })
          return;
        }
        // 查询用户拥有菜单
        _menu.getMenuTreeList(this.currentSystem.id, repsonse => {
          this.menuList = repsonse
        });
      })
    })
  },
  methods: {
		getChannel(response) {
			_channel.getChannelInfo({
				channelCode:response.channelCode
			}, (res) => {
				this.channelLoginCode = res.channelLoginCode
				this.channelInfo = res
			})
		},
    // 切换系统
    cutSystem () {
      window.location.replace(_request.passport_address)
    },
    cutMenu (index, show) {
      if (show)
        show = false
      else
        show = true
      this.$set(this.menuList[index], 'show', show)
    },
    // 登出
    loginOut () {
      _userinfo.loginOut(() => {
        _cookies.remove(_constant.loginKey);
        window.location.href = _request.passport_address + "/login"
      })
    },
    goUpdateLogs () {
      window.open(_request.doc_address)
    },
    // 用户详情
    getDetail () {
      window.location.replace(_request.general_address + '/user/info')
    }
  }
}
</script>

<style scoped>
.wapper {
  width: 100%;
  height: 100%;
  position: relative;
}
.logo {
  position: relative;
}
.logo img {
  height: 23px;
  margin: 15px 0 0 20px;
}
.logo span {
  font-weight: bold;
  font-size: 17px;
  position: absolute;
  top: 11px;
  left: 125px;
}
.menu-wapper {
  width: 200px;
  height: 100%;
  background: #fbfbfb;
  position: absolute;
  top: 0;
  left: 0;
  border-right: 1px solid #d6dbe5;
  z-index: 1;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
}
.menu-wapper::-webkit-scrollbar {
  display: none;
}
.menu-list {
  margin-top: 20px;
  overflow-y: auto;
  height: calc(100% - 80px);
}
.menu-list li a {
  display: inline-block;
  width: 100%;
  height: 45px;
  line-height: 45px;
  padding-left: 40px;
  text-align: left;
  vertical-align: middle;
  cursor: pointer;
  font-size: 14px;
}
.child-menus {
  position: absolute;
  left: 145px;
}
.content-wapper {
  width: 100%;
  height: 100%;
  padding-left: 200px;
}
.menu-children li a {
  display: inline-block;
  width: 100%;
  height: 35px;
  line-height: 35px;
  padding-left: 60px;
  text-align: left;
  vertical-align: middle;
  cursor: pointer;
  font-size: 12px;
}
.menu-children li a:hover {
  background: #d6dbe5;
  color: #383e43;
}
.menu-children-item {
  position: relative;
}
.menu-children-item::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 44px;
  height: 18px;
  width: 10px;
  border-left: 1px solid #909399;
  border-bottom: 1px solid #909399;
}
.menu-children-item::after {
  content: "";
  display: block;
  position: absolute;
  top: 19px;
  left: 44px;
  height: 18px;
  width: 10px;
  border-left: 1px solid #909399;
}
.menu-children li:last-child::after {
  display: none;
}
.router-link-active {
  background: #4875ae;
  color: #fff;
}
.nav-wapper {
  height: 50px;
  width: calc(100% - 200px);
  background: #f9f9f9;
  border-bottom: 1px solid #d6dbe5;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 5;
  padding: 0 20px;
  text-align: right;
  padding-top: 5px;
}
.nav-wapper img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #d6dbe5;
}
.nav-wapper span {
  font-weight: bold;
  margin-left: 5px;
}
.nav-menu {
  width: 100px;
  position: absolute;
  right: 20px;
  text-align: center;
  padding: 10px;
  background: #fbfbfb;
  border: 1px solid #d6dbe5;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.07);
}
.nav-menu li {
  display: inline-block;
  cursor: pointer;
  padding: 5px 0;
}
.nav-menu li:hover {
  color: #297ce0;
}
.nav-system {
  position: absolute;
  top: 10px;
  width: 100px;
  height: 25px;
  line-height: 25px;
  vertical-align: middle;
  color: #297ce0;
  border: 1px solid #297ce0;
  border-radius: 3px;
  text-align: center;
  cursor: pointer;
  font-size: 12px;
  padding-left: 15px;
}
.nav-system::before {
  content: "";
  background: url(../assets/switch.png);
  position: absolute;
  left: 15px;
  top: 4px;
  width: 15px;
  height: 15px;
  background-size: 15px 15px;
  background-repeat: no-repeat;
}
.main-wapper {
  width: 100%;
  height: 100%;
  padding-top: 50px;
  background: #fbfbfb;
  overflow-y: auto;
}
.menu-title {
  position: relative;
}
.menu-title::before {
  content: "";
  width: 10px;
  height: 10px;
  position: absolute;
  left: 20px;
  top: 16px;
  background: url("../assets/arrow-down.png");
  background-size: 10px 10px;
}
.close::before {
  transform: rotate(270deg);
}
.instructions-btn {
  position: absolute;
  right: 90px;
  height: 44px;
  line-height: 40px;
  vertical-align: middle;
  border-bottom: 3px solid #4875ae;
  padding: 0 15px;
}
</style>